/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import { __read, __spreadArray } from "tslib";
import { uuid } from '@slardar/sdk-template';
import { getCookieId, getDefaultBrowser, getDefaultDocument, getStorageItem, setStorageItem, getCurrentScript, now, } from '@slardar/sdk-web';
import { BATCH_REPORT_PATH, DEVICE_ID_COOKIE_NAME, SETTINGS_PATH, USER_ID_COOKIE_NAME, STORAGE_PREFIX, } from './constants';
export var getReportUrl = function (domain, path) {
    if (path === void 0) { path = BATCH_REPORT_PATH; }
    return "" + (domain && domain.indexOf('//') >= 0 ? '' : 'https://') + domain + path;
};
export var getSettingsUrl = function (domain, path) {
    if (path === void 0) { path = SETTINGS_PATH; }
    return "" + (domain && domain.indexOf('//') >= 0 ? '' : 'https://') + domain + path;
};
export var getViewId = function (pid) { return pid + "_" + now(); };
export var getDefaultSessionId = function () {
    return uuid();
};
export var toObservableArray = function (arr) {
    var observers = [];
    arr.observe = function (o) {
        observers.push(o);
    };
    arr.push = function () {
        var _a;
        var vs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            vs[_i] = arguments[_i];
        }
        vs.forEach(function (v) {
            observers.forEach(function (o) { return o(v); });
        });
        return (_a = [].push).call.apply(_a, __spreadArray([arr], __read(vs), false));
    };
    return arr;
};
export var getGlobalName = function () {
    var _a, _b, _c;
    var window = getDefaultBrowser();
    var document = getDefaultDocument();
    if (window && document) {
        return (((_c = (_b = (_a = getCurrentScript()) === null || _a === void 0 ? void 0 : _a.getAttribute('src')) === null || _b === void 0 ? void 0 : _b.match(/globalName=(.+)$/)) === null || _c === void 0 ? void 0 : _c[1]) || 'Slardar');
    }
};
export var getGlobalInstance = function () {
    var window = getDefaultBrowser();
    var globalName = getGlobalName();
    if (window && globalName) {
        return window[globalName];
    }
};
export var getStorageKey = function (bid) { return STORAGE_PREFIX + bid; };
export var getDefaultUserIdAndDeviceId = function (bid) {
    if (bid === void 0) { bid = ''; }
    var key = getStorageKey(bid);
    return (getStorageItem(key) || {
        // 兜底拿cookie 是为了切换时PV UV 不波动，后期稳定后可以去掉这个逻辑
        userId: getCookieId(USER_ID_COOKIE_NAME) || uuid(),
        deviceId: getCookieId(DEVICE_ID_COOKIE_NAME) || uuid(),
    });
};
export var hasSetStorageItem = function (bid) {
    if (bid === void 0) { bid = ''; }
    var key = getStorageKey(bid);
    return !!getStorageItem(key);
};
export var setStorageUserIdAndDeviceId = function (config) {
    var bid = config.bid, userId = config.userId, deviceId = config.deviceId;
    var key = getStorageKey(bid);
    setStorageItem(key, {
        userId: userId,
        deviceId: deviceId,
    });
};
//# sourceMappingURL=util.js.map